
import MessageChatSquareIcon from './Icons/MessageChatSquareIcon.vue'
export default {
    name: 'HxNFilters',
    components: {
        MessageChatSquareIcon
    },
    props: {
        filters: Object,
        selectedFilters: Array
    }
}
